import React from 'react'
import './App.css';
import Router from './Router/Route'

function App() {

  return (
    <Router />
  )
}

export default App;
